import { Avatar, Divider, Grid, Paper, Typography } from "@mui/material";
import React from "react";
import { FaEdit, FaEye, FaTimes, FaUserFriends } from "react-icons/fa";
import { RiVisaFill } from "react-icons/ri";
import CustomButton from "../../components/CustomButton/Index";
import CustomInputField from "../../components/CustomInputField/Index";
import CustomPill from "../../components/CustomPill/Index";
import CustomTable from "../../components/CustomTable/Index";
import endPoints from "../../config/endPoint";
import DashboardLayout from "../../layouts";
import offerStyles from "../../styles/pages/VisaCategory/index.style";
import axios from "axios";
import CustomTimeTable from "../../components/CustomTimeTable/Index";
import { useNavigate } from "react-router";
import { MdLogout } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import DashboardHeader from "../../components/DashHeader/Index";
import url from "../../API";
import ConfirmationDialog from "../../components/ConfirmationDialog/Index";
export default function News_letter() {
  const classes = offerStyles();
  const token = localStorage.getItem("tkn");
  const navigate = useNavigate();
  const formData = new FormData();
  const [state, setState] = React.useState({
    email: "",
    searchText: "",
    isUpdate: false,
  });
  const [visaList, setVisaList] = React.useState([]);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
  const [deletenwsId, setDeletenwsId] = React.useState(null);
  function table() {
    axios
      .get(url + "subscribe/getallsubscribe", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Handle the response
        setVisaList(response.data.subscribe);
        //console.log(response.data.subscribe);
      })
      .catch((error) => {
        // Handle errors
        //console.error("Error fetching data:", error);
      });
  }
  React.useEffect(() => {
    table();
  }, []);
  const handleDelete = (idx) => {
    setDeletenwsId(idx);
    setConfirmDialogOpen(true);
  };
  const handleSaveVisaCategory = () => {
    if (!state.email.endsWith("@gmail.com")) {
      toast.error("Email is not valid. It should end with '.com'", {
        position: "top-center",
      });
      return; // Exit the function if the email is not valid
    }
    axios
      .post(
        url + "subscribe/createsubscribe",
        {
          email: state.email,
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}`, // Example authorization header
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Created Sucessfully", {
            position: "top-center",
          });
          window.scrollTo({ top: 300, behavior: "smooth" });
        }
        table();
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      email: "",
    });
  };
  const handleVisaCategoryDelete = () => {
    axios
      .post(
        url + "subscribe/deletesubscribe",
        {
          id: deletenwsId,
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}`, // Example authorization header
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Deleted Sucessfully", {
            position: "top-center",
          });
        }
        table();
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setConfirmDialogOpen(false);
  };
  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleUpdateVisaCategory = (idx) => {
    if (!state.email.endsWith(".com")) {
      toast.error("Email is not valid. It should end with '.com'", {
        position: "top-center",
      });
      return; // Exit the function if the email is not valid
    }
    axios
      .post(
        url + "subscribe/updatesubscribe",
        {
          id: idx,
          email: state.email,
        },
        {
          headers: {
            /* Your headers here */
            "Content-Type": "application/json", // Example header
            Authorization: `Bearer ${token}`, // Example authorization header
          },
        }
      )
      .then((r) => {
        if (r.data.status == 200) {
          toast.success("Updated Sucessfully", {
            position: "top-center",
          });
          window.scrollTo({ top: 300, behavior: "smooth" });
        }
        table();
      })
      .catch((error) => {
        //console.error("Error fetching data:", error);
        // Handle error here
      });
    setState({
      email: "",
      isUpdate: false,
    });
  };
  return (
    <div className={classes.container}>
      <DashboardLayout />
      <div className={classes.contentSection}>
        <DashboardHeader />
        <Divider className={classes.divider} />
        <div
          className={classes.contentHead}
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {" "}
            <p style={{ marginTop: "2px", fontSize: "22px" }}>News Letter</p>
          </div>
        </div>
        {/* <Divider className={classes.divider} /> */}
        <div className={classes.contentMain}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} className="content" alignItems={"end"}>
              <Grid item xs={5}>
                <CustomInputField
                  type="email"
                  label="Email"
                  fullWidth
                  value={state.email}
                  onChange={(e) => {
                    const input = e.target.value;
                    // Ensure input does not exceed 50 characters
                    const trimmedInput = input.slice(0, 50);
                    setState({
                      ...state,
                      email: trimmedInput,
                    });
                  }}
                />
              </Grid>
              {/* <Grid item xs={5}>
                <CustomInputField
                  type="File"
                  fullWidth
                  onChange={(e) =>
                    setState({
                      ...state,
                      visaImg: e.target.value,
                    })
                  }
                />
              </Grid> */}
              <Grid item xs={2} alignItems="end">
                {state.isUpdate ? (
                  <CustomButton
                    text={"Update"}
                    variant="contained"
                    color="warning"
                    fullWidth
                    onClick={(e) => {
                      if (!!state.email) {
                        handleUpdateVisaCategory(state.visaId);
                      } else {
                        toast.error("Fill all the information", {
                          position: "top-center",
                        });
                      }
                    }}
                  />
                ) : (
                  <CustomButton
                    text={"create"}
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                      if (!!state.email) {
                        handleSaveVisaCategory();
                      } else {
                        toast.error("Fill all the information", {
                          position: "top-center",
                        });
                      }
                    }}
                  />
                )}
              </Grid>
            </Grid>
            <ToastContainer />
          </Paper>
          <p className={classes.title}>Emails List</p>
          <Paper className={classes.paper}>
            <CustomInputField
              label="Search..."
              fullWidth
              value={state.searchText}
              onChange={(e) =>
                setState({
                  ...state,
                  searchText: e.target.value,
                })
              }
              className="searchField"
            />
            <CustomTimeTable
              fullWidth
              cols={["Sl No.", "Email", "Action"]}
              rows={[
                ...visaList
                  .filter((l) => {
                    const News_letter = l.email?.toLowerCase() || "";

                    const searchLower = (state.searchText || "").toLowerCase();
                    return (
                      News_letter.includes(searchLower) ||
                      searchLower === undefined
                    );
                  })
                  .map((vs, idx) => [
                    idx + 1,
                    vs.email,
                    <span className={classes.actionBtn}>
                      <CustomButton
                        variant="contained"
                        color="error"
                        onClick={(e) => handleDelete(vs.id)}
                        icon={<FaTimes />}
                      />
                      <CustomButton
                        variant="contained"
                        color="warning"
                        onClick={(e) => {
                          setState({
                            email: vs.email,
                            isUpdate: true,
                            visaId: vs.id,
                          });
                          window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        icon={<FaEdit />}
                      />
                    </span>,
                  ]),
              ]}
            />
          </Paper>
        </div>
      </div>
      <ConfirmationDialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
        onConfirm={handleVisaCategoryDelete}
      />
    </div>
  );
}
